import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes = [
  {
    path: '/login',
    name: 'UserLogin',
    component: () => import('@/views/LoginView.vue'),
    meta: { layout: 'peakslog', guestOnly: true }
  },
  {
    path: '/summary',
    name: 'Dashboard',
    component: () => import('@/views/DashboardView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true }
  },
  {
    path: '/map',
    name: 'PeakMap',
    component: () => import('@/views/MapView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true, hideSyncBar: true }
  },
  {
    path: '/challenges',
    name: 'UserChallenges',
    component: () => import('@/views/AchievementsView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true }
  },
  {
    path: '/challenges/legenda',
    name: 'BadgeLegend',
    component: () => import('@/views/BadgeLegendView.vue'),
    meta: { requiresAuth: true, layout: 'peakslog', appNav: true }
  },
  {
    path: '/peaks',
    name: 'MyPeaks',
    component: () => import('@/views/PeaksView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true }
  },
  {
    path: '/activities',
    name: 'Activities',
    component: () => import('@/views/ActivitiesView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/rankings',
    name: 'Rankings',
    component: () => import('@/views/RankingsView.vue'),
    meta: { requiresAuth: true, requiresStrava: true }
  },
  {
    path: '/error',
    name: 'Error',
    component: () => import('@/views/ErrorView.vue'),
    meta: { layout: 'peakslog' }
  },
  {
    path: '/admin/challenges',
    name: 'AdminChallenges',
    component: () => import('@/views/AdminChallengesView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/users',
    name: 'AdminUsers',
    component: () => import('@/views/AdminUsersView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/peaks',
    name: 'AdminPeaks',
    component: () => import('@/views/AdminPeaksView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/countries',
    name: 'AdminCountries',
    component: () => import('@/views/AdminCountriesView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/admin/map',
    name: 'AdminMap',
    component: () => import('@/views/AdminMap.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/connect-strava',
    name: 'StravaConnect',
    component: () => import('@/views/ConnectStravaView.vue'),
    meta: { requiresAuth: true, layout: 'peakslog' }
  },
  {
    path: '/share',
    name: 'ShareSummary',
    component: () => import('@/views/ShareView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true, hideSyncBar: true }
  },
  {
    path: '/share/challenge/:id',
    name: 'ShareChallenge',
    component: () => import('@/views/ShareView.vue'),
    meta: { requiresAuth: true, requiresStrava: true, layout: 'peakslog', appNav: true, hideSyncBar: true }
  },
  {
    path: '/',
    name: 'Landing',
    component: () => import('@/views/LandingView.vue'),
    meta: { layout: 'peakslog', guestOnly: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  console.log('Router guard:', {
    path: to.path,
    requiresAuth: to.meta.requiresAuth,
    requiresStrava: to.meta.requiresStrava,
    requiresAdmin: to.meta.requiresAdmin,
    isAuthenticated: authStore.isAuthenticated,
    isStravaConnected: authStore.isStravaConnected,
    isAdmin: authStore.isAdmin,
    user: authStore.user
  })
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next('/login')
  } else if (to.meta.guestOnly && authStore.isAuthenticated) {
    next('/summary')
  } else if (to.meta.requiresStrava && authStore.isAuthenticated && !authStore.isStravaConnected) {
    console.log('Redirecting to /connect-strava because requiresStrava and not connected')
    next('/connect-strava')
  } else if (to.meta.requiresAdmin && authStore.isAuthenticated && !authStore.isAdmin) {
    console.log('Redirecting to /summary because requiresAdmin and not admin')
    next('/summary')
  } else {
    next()
  }
})

export default router